import React, { Component } from 'react';

import tableConfig from './config';
import history from '../../../utils/history';
import * as appConfig from '../../../config';
import * as httpUtils from '../../../utils/httpUtils';
import withBaseState from '../../common/withBaseState';
import { SALES_CREATE } from '../../../data/enums/Route';
import PageView from '../../common/pagination/PageView';
import * as queryService from '../../common/query.service';
import { ENTRY_LOG_CONFIG } from '../../common/domain.config';
import { BillingSnackBar } from '../../../components/BillingMDC';
import * as snackService from '../../common/snack.service';
import * as filterUtil from '../../../utils/filterUtil';
import TableHeader from '../../../components/TableHeader/TableHeader';
import PageNumber from '../../../components/PrintComponent/PageNumber';
import EntryLogStyled from './EntryLogStyled';
import { Grid, Cell, Icon } from '../../../components/BillingMDC';
import { clone } from '../../../utils/arrayProcessor';
import {groupPrintDataSet} from "../../common/print.service";

class EntryLog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: {
        filter: false,
        menu: false,
        searchBox: false,
      },
      snack: { ...snackService.snackParameters },
      queryParameters: { ...queryService.queryParameters },
      data: {
        list: [],
        total: 1,
      },
      print: {
        start: false,
      },
      printButtonClicked: false,
      dataList: [],
      printData: [],
      date: filterUtil.getCurrentDate(),
    };
    this.dataListLength = 0;

    this.reference = {
      tableHeader: React.createRef(),
      tableFooter: React.createRef(),
      tableBody: React.createRef(),
    };

    const { downloadList } = this.props;

    this.basePaginationService = new queryService.QueryClass(
      this.setQueryParameters,
      this.getQueryParameters,
      this.getTableDataForGrid,
      downloadList,
    );
    this.basePaginationService.resetFilter();
  }

  /** adjust table width and height according to screen * */
  componentDidMount() {
    this.getTableDataForGrid();
    window.addEventListener('keydown', this.handleKeyDown);
  }
  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }
  
  handleKeyDown = e => {
    const charCode = String.fromCharCode(e.which).toLowerCase();
    if ((e.ctrlKey && charCode === 'p') || (e.metaKey && charCode === 'p')) {
      e.preventDefault();
      this.handlePrintClick();
    }
  };

  setQueryParameters = (queryParameters, callBack = () => null) => this.setState({ queryParameters }, callBack);

  getQueryParameters = () => {
    const { queryParameters } = this.state;

    return queryParameters;
  };

  sendErrorMessage = (message = 'Error while fetching data') => {
    const snack = snackService.generateFailureMessage(message);
    this.setState({ snack });
  };
  /** get data for grid, adjust loading flag */
  getTableDataForGrid = async (print =false) => {
    const { getList } = this.props;
    const { queryParameters,data } = this.state;
    let query = clone(queryParameters);
    query.pagination.limit = 2000;
    await getList(print ? query:queryParameters).then(response => {
      data.list = response.list;
      data.total = response.total;
      this.setState({ data },()=>{
        print && this.groupPrintDataSetNew();
      });
    });
  };
 
  handlePrintClick = async() => {
    const self = this;
    await this.getTableDataForGrid(true);
    self.setState({ printButtonClicked: true }, () => {
      setTimeout(() => {
        window.print();
      }, 500);
    });
    window.onafterprint = function () {
      self.setState({ printButtonClicked: false });
    };
  };

  handleFabButtonClick = () => history.push(`${SALES_CREATE}`);

  afterPrint = userId => {
    const self = this;
    const { printDetails } = this.state;
    printDetails.printedBy = userId;

    window.onafterprint = function () {
      self.setState({ startPrint: false });
      httpUtils
        .post(`${appConfig.baseUrl}print`, printDetails)
        .then(response => {
          if (response.success) {
            window.location.reload();
          }
        })
        .catch(error => {
          {
            console.log('error', error);
          }
        });
    };
  };
  groupPrintDataSetNew() {
    const { data  } = this.state;
    const {company} =this.props;
    const printInfoBill = {...company,printInfo:{...company.printInfo,batchEnabled:false}} || {};
    const orders = clone(data.list);
    const dataList = groupPrintDataSet(orders, printInfoBill, tableConfig);
    this.setState({ dataList });
  }

  controlDisplay = (label, value) => {
    const { display } = this.state;
    display[label] = value;
    this.setState(display);
  };

  closeSnack = () => {
    const snack = snackService.resetSnack();
    this.setState({ snack });
  };
  render() {
    const { queryParameters, data, display, printButtonClicked, dataList, date, snack } = this.state;
    const { serverResponseWaiting, company } = this.props;
    return (
      <EntryLogStyled className="entry-log">
        <div className={printButtonClicked ? 'no-print' : 'display-block'}>
          <PageView
            headerConfig={{ filter: true, create: false, print: true }}
            domainConfig={ENTRY_LOG_CONFIG}
            serverResponseWaiting={serverResponseWaiting}
            display={display}
            controlDisplay={this.controlDisplay}
            handleSearchChange={this.basePaginationService.handleSearchInputChange}
            clearSearchText={this.basePaginationService.clearSearchText}
            resetFilter={this.basePaginationService.resetFilter}
            handleDateRangeChange={this.basePaginationService.handleDateRangeChange}
            handleDownloadClick={this.basePaginationService.handleDownloadClick}
            tableConfig={tableConfig}
            queryParameters={queryParameters}
            data={data}
            onPageSelect={this.basePaginationService.onPageSelect}
            handleTableSorting={this.basePaginationService.handleTableSorting}
            handlePrintClick={this.handlePrintClick}
            handleFabButtonClick={this.handleFabButtonClick}
          />
        </div>

        <div className={printButtonClicked ? 'display-block portrait portrait-type' : 'no-print'}>
          <div>
            {dataList.map((chunk, key) => {
              const { list = [], page = 0,remainingLines=[] } = chunk;
              return (
                <div className="print-body zoom-reduce">
                  <div className="pickList-body card-body">
                    <header>
                      <Grid className="flex">
                        <Cell col={2} tablet={2} phone={2} className="left">
                          <div className="header-title">{company.title}</div>
                          <span className="header-title-content">
                            <span className="active-opacity-text">Address: </span>
                            <span>{company.address}</span>
                          </span>
                          <span className="header-title-content">
                            <span className="active-opacity-text">Phone: </span>
                            <span>{company.phone}</span>
                          </span>
                          <span className="no-margin-bottom header-title-content">
                            <span className="active-opacity-text">PAN No: </span>
                            <span>{company.panNumber}</span>
                          </span>
                        </Cell>
                        <Cell col={4} tablet={4} phone={4} className="center">
                          <div className="center-align">
                            <h2>{ENTRY_LOG_CONFIG.title}</h2>
                            <div className="default-margin-top-3">
                              <span className="header-title-content no-margin-bottom">
                                <span className="active-opacity-text">
                                  Report from
                                  <span className="date-rendered">
                                    {` ${filterUtil.formatToReadableDate(
                                      queryParameters.date.start,
                                    )} - ${filterUtil.formatToReadableDate(queryParameters.date.end)}`}
                                  </span>
                                </span>
                              </span>
                              <span className="header-title-content"></span>
                            </div>
                          </div>
                        </Cell>
                        <Cell col={2} tablet={2} phone={2} className="right">
                          <div className="header-menu-right">
                            <span>
                              <span className="">Date: </span>
                              <span>{filterUtil.formatToReadableDate(date)}</span>
                            </span>
                          </div>
                        </Cell>
                      </Grid>
                    </header>
                    <div className="fixed-table-wrapper">
                      <table className="pdf-table">
                        <TableHeader headerDetails={tableConfig.header} filterHeaderLabel={false} />
                        {tableConfig.getTableBody({ dataList: list,remainingLines:remainingLines })}
                      </table>
                    </div>
                  </div>
                  <div className="footer-block">
                    <PageNumber value={page} totalPage={dataList.length} />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <BillingSnackBar closeSnack={this.closeSnack} config={snack} />
      </EntryLogStyled>
    );
  }
}

const EntryLogWithState = withBaseState(EntryLog);

export default EntryLogWithState;
